import { Core } from "@faire/design-tokens";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { EmbeddedLink } from "@faire/web--source/ui/EmbeddedLink";
import styled from "styled-components";
var PILL_BORDER_RADIUS = 100;
var StyledPill = styled(EmbeddedLink).withConfig({
    componentId: "sc-37e63959-0"
})([
    "display:flex;align-items:center;padding:",
    ";border-radius:",
    ";background-color:",
    ";white-space:nowrap;margin-right:",
    ";&,&:hover,&:focus,&:focus-within{text-decoration:none;}",
    "{&:hover{background-color:",
    ";}}"
], getSpacing("1x", "3x", "1x", "2x"), getSpacing(PILL_BORDER_RADIUS), Core.surface.subdued, getSpacing("2x"), responsiveMediaQueries.tabletAndAbove, Core.surface.subdued);
var StyledTextWrapper = styled.div.withConfig({
    componentId: "sc-37e63959-1"
})([
    "display:flex;flex-direction:column;justify-content:center;"
]);
export var SearchIconPillStyles;
(function(SearchIconPillStyles) {
    SearchIconPillStyles.Pill = StyledPill;
    SearchIconPillStyles.TextWrapper = StyledTextWrapper;
})(SearchIconPillStyles || (SearchIconPillStyles = {}));
